// removed by extract-text-webpack-plugin
module.exports = {"banner":"_2vF4RBvD8Y2gVdKOtBqLJA","banner__quotation":"_2DQ2ZWTIvypPdRq3XJb_5u","banner__quotationText":"_2Q0hkjGs9brtzE1cvul6tL","banner__bubble":"KJBdppI8GCYnt-Ugb1Oyn","banner__bubbleContainer":"_2fwPlawA5havIIwP7YSUTI","banner__bubbleText":"_1w6jGP3ogXeVSU_Cv09n9u","banner__quotationTextContainer":"_3tuQPD09oloHSIJpkYPSF7","banner__bubbleBorderTop":"_2RTYlU4fDivJ1A0bQZDjsg","banner__bubbleBorderBottom":"_3PxTOCz5-YkJxu6I2iFXD5","banner__linkContainer":"x9YhtJFYXZutELcz_eOQO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Banner/Banner.module.scss
// module id = 733
// module chunks = 0